var render = function render(){var _vm=this,_c=_vm._self._c;return _c('plain-layout',{attrs:{"isPlain":true,"showTerms":false}},[_c('common-content-spacer',{attrs:{"height":"small"}},[_c('h1',{},[_vm._v("Authenticating...")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }